import React, { MutableRefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './index.module.scss';
import Head from 'next/head';
import { PageLayout } from '@/components/pagelay';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import classNames from 'classnames';
import useRequest from '@/utils/useRequest';
import * as echarts from 'echarts';
import CountUp from 'react-countup';
import { cloneDeep, throttle } from 'lodash';
import useObserver from '@/utils/useObserver';
import { getHead, getServerSideProps } from '@/utils/useHead';
import { useTranslations } from 'next-intl';

interface IProps {

}
export { getServerSideProps }
export default ({ navDetail }: any) => {
  const [data, setData] = useState<any>([])
  const request = useRequest()
  const forumRef = useRef<any>()
  const areaRef = useRef<any>()
  const introRef = useRef<any>()
  const [animate, setIsAnimate] = useState({
    isIntro: false,
    isForum: false,
    isArea: false
  });
  const timerRefs = useRef<Record<string, NodeJS.Timeout>>({});
  const [isLoadSwiper, setIsLoadSwiper] = useState(false)
  const visitorSwiperRef = useRef<any>()
  const visitorRef = useRef<any>()
  const [swiperData, setSwiperData] = useState<any>()
  const t = useTranslations();

  const chunkArray = useCallback((arr: any, chunkSize: number) => {
    const chunkedArray = [];
    let index = 0;
    while (index < arr.length) {
      const end = Math.min(index + chunkSize, arr.length);
      chunkedArray.push(arr.slice(index, end));
      index = end;
    }
    return chunkedArray;
  }, [])

  const handleMouseEnter = (ref: any) => {
    let nextTransForm = '';
    // 轮播图从暂停位置移动到原本应到的位置所用的时间
    let nextTime = 0;
    if (ref.current && ref.current.swiper.autoplay) {
      const swiperDom = ref.current.swiper.el.children[0];
      // 轮播图原本应移动到的位置
      nextTransForm = swiperDom.style.transform;
      let nextTransPosition = parseInt(swiperDom.style.transform?.split('translate3d(')[1]?.split('px')[0], 10);
      // 鼠标悬浮时时轮播图位置
      const nowTransPosition = ref.current.swiper.getTranslate();
      // 计算轮播图从暂停位置移动到原本应到的位置所用的时间
      const swiperSlideWidth = swiperDom.children[0]?.getBoundingClientRect().width;
      nextTime = 6000 * (Math.abs(Math.abs(nextTransPosition) - Math.abs(nowTransPosition)) / swiperSlideWidth);
      setSwiperData({ nextTransForm, nextTime });
      const instance = ref.current.swiper.getTranslate();
      ref.current.swiper.setTranslate(instance);
      ref.current.swiper.autoplay.stop();
    }
  }
  const handleMouseLeave = useCallback((ref: any) => {
    if (swiperData) {
      const { nextTransForm, nextTime } = swiperData;
      if (ref.current && ref.current.swiper?.autoplay) {
        const swiperDom = ref.current.swiper.el.children[0];

        swiperDom.style.transform = nextTransForm;
        swiperDom.style.transitionDuration = '1000ms';
        ref.current.swiper?.autoplay.start();
      }
    }
  }, [swiperData])


  const setObserver = useCallback((ref: any, code: string) => {
    useObserver(
      () => {
        if (timerRefs.current[code]) {
          clearTimeout(timerRefs.current[code]);
        }
        setIsAnimate(prev => ({ ...prev, [code]: true }));
      },
      () => {
        // timerRefs.current[code] = setTimeout(() => {
        //   setIsAnimate(prev => ({ ...prev, [code]: false }));
        // }, 1200)
      },
      0.2
    ).observe(ref)
  }, [animate])

  const animateLoad = useCallback(() => {
    setObserver(forumRef.current, 'isForum')
    setObserver(areaRef.current, 'isArea')
    setObserver(introRef.current, 'isIntro')

  }, [setObserver])

  const getData = useCallback(async () => {
    const { data } = await request.get(`/getLogoList`, {
      params: {
        limit: 999,
        category_id: 1
      }
    })
    setData(data?.data?.list)
    setIsLoadSwiper(true)
  }, [])

  useEffect(() => {
    getData()
    animateLoad()
    return () => {
      Object.values(timerRefs.current).forEach(clearTimeout);
      // [forumRef, areaRef, introRef].forEach(ref => {
      //   if (ref.current) observer.unobserve(ref.current);
      // });
    };
  }, [])


  return (
    <PageLayout title={(
      <>
        <h1>{navDetail?.sub_title}</h1>
        <p style={{ fontWeight: 'normal' }}>{navDetail?.brief}</p>
      </>
    )}>
      <div className={styles.container}>
        {getHead(navDetail)}
        <i className={styles.bg1}></i>
        <i className={styles.bg2}></i>
        <div ref={introRef} className={classNames([styles.newPro, { [styles.animate]: animate.isIntro }])}>
          <div className={styles.left}>
            <h2>{t('visitorWhy.annual')}</h2>
            <p>{t('visitorWhy.annualText')}</p>
          </div>
          <div className={styles.right}>
            <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/visitor-why-img1.png" alt="" />
            <p>{t('visitorWhy.photoTip')}</p>
          </div>
        </div>
        <div className={styles.forum}>
          <div ref={forumRef} className={classNames([{ [styles.animate]: animate.isForum }])}>
            <div className={styles.left}>
              <div>
                <img style={{ filter: 'brightness(0.8)' }} onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} loading='lazy' src='/image/visitor-why-forum.png' alt="" />
              </div>
            </div>
            <div className={styles.right}>
              <h2>{t('visitorWhy.conference')}</h2>
              <p>{t('visitorWhy.conferenceText')}</p>
            </div>
          </div>
        </div>
        <div ref={areaRef} className={classNames([styles.area, { [styles.animate]: animate.isArea }])}>
          <div className={styles.left}>
            <h2>{t('visitorWhy.area')}</h2>
            <p>{t('visitorWhy.areaText')}</p>
          </div>
          <div className={styles.right}>
            <div>
              <img style={{ filter: 'brightness(0.8)' }} onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/visitor-why-area.png" loading='lazy' alt="" />
            </div>
          </div>
        </div>
        <div className={styles.cates}>
          <div className={styles.info}>
            <h2>{t('visitorWhy.exhCate')}</h2>
            <div>
              <div className={styles.item}>
                <div className={styles.cate1}>
                  <span>{t('visitorWhy.cates.cate1')}</span>
                  <p>
                    <CountUp
                      end={31.2}
                      duration={1}
                      enableScrollSpy
                      decimals={1}
                    />
                    <span style={{ fontSize: '18px' }}>%</span>
                  </p>
                </div>
                <div className={styles.cate2}>
                  <span>{t('visitorWhy.cates.cate2')}</span>
                  <p>
                    <CountUp
                      end={2.5}
                      duration={1}
                      enableScrollSpy
                      decimals={1}
                    />
                    <span style={{ fontSize: '18px' }}>%</span>
                  </p>
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.cate3}>
                  <span>{t('visitorWhy.cates.cate3')}</span>
                  <p>
                    <CountUp
                      end={42.5}
                      duration={1}
                      enableScrollSpy
                      decimals={1}
                    />
                    <span style={{ fontSize: '18px' }}>%</span>
                  </p>
                </div>
                <div className={styles.cate4}>
                  <span>{t('visitorWhy.cates.cate4')}</span>
                  <p>
                    <CountUp
                      end={2.8}
                      duration={1}
                      enableScrollSpy
                      decimals={1}
                    />
                    <span style={{ fontSize: '18px' }}>%</span>
                  </p>
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.cate5}>
                  <span>{t('visitorWhy.cates.cate5')}</span>
                  <p>
                    <CountUp
                      end={13.5}
                      duration={1}
                      enableScrollSpy
                      decimals={1}
                    />
                    <span style={{ fontSize: '18px' }}>%</span>
                  </p>
                </div>
                <div className={styles.cate6}>
                  <span>{t('visitorWhy.cates.cate6')}</span>
                  <p>
                    <CountUp
                      end={7.5}
                      duration={1}
                      enableScrollSpy
                      decimals={1}
                    />
                    <span style={{ fontSize: '18px' }}>%</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            onMouseEnter={(e) => handleMouseEnter(visitorSwiperRef)}
            onMouseLeave={(e) => handleMouseLeave(visitorSwiperRef)}
          >
            {isLoadSwiper && <Swiper
              ref={visitorSwiperRef}
              style={{ paddingBottom: '30px' }}
              modules={[Autoplay]}
              spaceBetween={10}
              autoplay={{
                delay: 0,
                // pauseOnMouseEnter: true,
                stopOnLastSlide: false,
                disableOnInteraction: false,
              }}
              centeredSlides
              observer
              observeParents
              speed={2000}
              loop
              slidesPerView='auto'
            >
              {
                data.length &&
                chunkArray(data, 5).map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className={styles.logos}>
                      {
                        item.map((child: any, index: number) => (
                          <div key={index}>
                            <a href={child.url ? child.url : "javascript:;"} target={child.url ? '_blank' : '_self'}>
                              <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src={child.image} alt="" />
                            </a>
                          </div>
                        ))
                      }

                    </div>
                  </SwiperSlide>
                ))
              }

            </Swiper>}
          </div>
        </div>
        <style global jsx>
          {
            `
            .swiper-wrapper,
            .swiper-slide{
              width:auto;
              transition-timing-function: linear !important;
            }
            `
          }
        </style>
      </div>
    </PageLayout >

  );
};


